export const appLogin = {
    create: function(){
        var that = this;
        that.bindEvents();
    },
    bindEvents: function(){
        var that = this;
        // changing label position on focus/blur
        $(document).on('focus', '.js-login-field', function(){
            var theWrapper = $(this).closest('.js-login-wrapper');
            $(theWrapper).attr('data-state', 'label');
        });
        $(document).on('blur', '.js-login-field', function(){
            var hasValue = $(this).val().length > 0 ? true : false,
                theWrapper = $(this).closest('.js-login-wrapper');
            if(!hasValue){
                $(theWrapper).attr('data-state', 'placeholder');
            }
        });
    }
};
